module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.componentListIndicators), function(indicator, index) {
    return _c('div', _vm._l((indicator.colorConditions), function(condition, index) {
      return _c('div', [(indicator.value >= condition.minValue & indicator.value < condition.maxValue) ? _c('div', [(indicator.width == 'Small') ? _c('div', {
        staticClass: "col-lg-2"
      }, [_c('a', {
        staticClass: "block block-link-hover3"
      }, [_c('div', {
        staticClass: "block-content block-content-full clearfix",
        style: ({
          backgroundColor: condition.colorBackground
        })
      }, [_c('i', {
        staticClass: "fa-2x text-white pull-right",
        class: indicator.favIcon
      }), _vm._v(" "), _c('span', {
        staticClass: "h6 font-w700 text-white-op"
      }, [_vm._v(_vm._s(indicator.value))]), _vm._v(" "), _c('span', {
        staticClass: "h6 text-white-op"
      }, [_vm._v(_vm._s(indicator.label[_vm.actualLanguage]))])])])]) : _vm._e(), _vm._v(" "), (indicator.width == 'Medium') ? _c('div', {
        staticClass: "col-lg-3"
      }, [_c('a', {
        staticClass: "block block-link-hover3"
      }, [_c('div', {
        staticClass: "block-content block-content-full clearfix",
        style: ({
          backgroundColor: condition.colorBackground
        })
      }, [_c('i', {
        staticClass: "fa-2x text-white pull-right",
        class: indicator.favIcon
      }), _vm._v(" "), _c('span', {
        staticClass: "h6 font-w700 text-white-op"
      }, [_vm._v(_vm._s(indicator.value))]), _vm._v(" "), _c('span', {
        staticClass: "h6 text-white-op"
      }, [_vm._v(_vm._s(indicator.label[_vm.actualLanguage]))])])])]) : _vm._e(), _vm._v(" "), (indicator.width == 'Large') ? _c('div', {
        staticClass: "col-lg-4"
      }, [_c('a', {
        staticClass: "block block-link-hover3"
      }, [_c('div', {
        staticClass: "block-content block-content-full clearfix",
        style: ({
          backgroundColor: condition.colorBackground
        })
      }, [_c('i', {
        staticClass: "fa-2x text-white pull-right",
        class: indicator.favIcon
      }), _vm._v(" "), _c('span', {
        staticClass: "h6 font-w700 text-white-op"
      }, [_vm._v(_vm._s(indicator.value))]), _vm._v(" "), _c('span', {
        staticClass: "h6 text-white-op"
      }, [_vm._v(_vm._s(indicator.label[_vm.actualLanguage]))])])])]) : _vm._e(), _vm._v(" "), (indicator.width == 'Full') ? _c('div', {
        staticClass: "col-lg-12"
      }, [_c('a', {
        staticClass: "block block-link-hover3"
      }, [_c('div', {
        staticClass: "block-content block-content-full clearfix",
        style: ({
          backgroundColor: condition.colorBackground
        })
      }, [_c('i', {
        staticClass: "fa-2x text-white pull-right",
        class: indicator.favIcon
      }), _vm._v(" "), _c('span', {
        staticClass: "h6 font-w700 text-white-op"
      }, [_vm._v(_vm._s(indicator.value))]), _vm._v(" "), _c('span', {
        staticClass: "h6 text-white-op"
      }, [_vm._v(_vm._s(indicator.label[_vm.actualLanguage]))])])])]) : _vm._e()]) : _vm._e()])
    }), 0)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-012f4525","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/measurements/SubComponents/ApiDeviceListIndicatorV1p00.vue
// module id = 1478
// module chunks = 4